export type User = {
    id: string;
    date:string;
    transactTime:string;
    tradeID: string;
    legRefID:string;
    trader:string;
    clearer:string;
    clearingAccount:string;
    derivative:string;
    tradeType:string;
    parentCompany:string;
    book:string;
    strategy:string;
    symbolCode:string;
    marketID:string;
    contractName:string;
    volume:string;
    unit:string;
    startDate:string;
    endDate:string;
    price:string;
    tick:string;
    holiday:string;
    type:string;
    EFSCode:string;
    broker:string;
    orderID:string;
    clientOrdID:string;
    tradeReportID:string;
    notes:string;
    lastEditedDate:string;
    lastEditPerson:string;
  };
  
  export const fakeData: User[] = [
    {
        id: "11000001942975",
        date: "28-Mar-25",
        transactTime: "28-Mar-25-06:39:05.600",
        tradeID: "11000001942975",
        legRefID: "11000001942977",
        trader: "cgriffin13",
        clearer: "RJ OBrien",
        clearingAccount: "DB9CRAC2",
        derivative: "Swaps",
        tradeType: "Cleared",
        parentCompany: "CC",
        book: "Cr2",
        strategy: "1003",
        symbolCode: "DBI",
        marketID: "6581675",
        contractName: "Dubai 1st Line",
        volume: "-19.0",
        unit: "bbl",
        startDate: "01-Apr-25",
        endDate: "30-Apr-25",
        price: "74.61",
        tick: "1000",
        holiday: "Singapore Platts",
        type: "Spread",
        EFSCode: "EFS-123",
        broker: "Oil Brokerage Limited.-Broker",
        orderID: "11000001942974",
        clientOrdID: "11000001942974",
        tradeReportID: "233476",
        notes: "Swaps API Exchange Trades",
        lastEditedDate: "March 28, 2025, 12:15 p.m.",
        lastEditPerson: "None"
    },
    
  ];
  
  //50 us states array
  export const usStates = [
    "Alabama",
    "Alaska",
    "Arizona",
    "Arkansas",
    "California",
    "Colorado",
    "Connecticut",
    "Delaware",
    "Florida",
    "Georgia",
    "Hawaii",
    "Idaho",
    "Illinois",
    "Indiana",
    "Iowa",
    "Kansas",
    "Kentucky",
    "Louisiana",
    "Maine",
    "Maryland",
    "Massachusetts",
    "Michigan",
    "Minnesota",
    "Mississippi",
    "Missouri",
    "Montana",
    "Nebraska",
    "Nevada",
    "New Hampshire",
    "New Jersey",
    "New Mexico",
    "New York",
    "North Carolina",
    "North Dakota",
    "Ohio",
    "Oklahoma",
    "Oregon",
    "Pennsylvania",
    "Rhode Island",
    "South Carolina",
    "South Dakota",
    "Tennessee",
    "Texas",
    "Utah",
    "Vermont",
    "Virginia",
    "Washington",
    "West Virginia",
    "Wisconsin",
    "Wyoming",
    "Puerto Rico",
  ];
  export const citiesList = [
    "San Francisco",
    "Richmond",
    "Riverside",
    "Los Angeles",
    "Blacksburg",
    "New York",
  ];
  
  export const usStateList = [
    "California",
    "Virginia",
    "South Carolina",
    "New York",
    "Texas",
  ];
  